import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "textarea", "submit", "thinking", "emptyState"]

  connect() {
    this.#observeMessages()
  }

  disconnect() {
    this.observer?.disconnect()
    clearTimeout(this.recoveryTimer)
  }

  // Called when agent-stream controller dispatches "done" (streaming finished,
  // final rendered message expected via Turbo Stream shortly after).
  onStreamDone() {
    clearTimeout(this.recoveryTimer)
    this.recoveryTimer = setTimeout(() => {
      this.#toggleThinking(false)
      this.#toggleForm(true)
    }, 5000)
  }

  submitOnEnter(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()

      const message = this.textareaTarget.value.trim()
      if (message.length > 0 && !this.textareaTarget.disabled) {
        this.formTarget.requestSubmit()
      }
    }
  }

  submitPrompt(event) {
    const prompt = event.params.prompt
    this.textareaTarget.value = prompt
    this.textareaTarget.dispatchEvent(new Event("input"))
    this.formTarget.requestSubmit()
  }

  onSubmitStart() {
    this.savedMessage = this.textareaTarget.value
    this.textareaTarget.value = ""
    this.textareaTarget.dispatchEvent(new Event("input"))
    this.#toggleThinking(true)
    this.#toggleForm(false)
    this.#hideEmptyState()
  }

  onSubmitEnd(event) {
    if (!event.detail.success) {
      this.textareaTarget.value = this.savedMessage
      this.textareaTarget.dispatchEvent(new Event("input"))
      this.#toggleThinking(false)
      this.#toggleForm(true)
    }
  }

  #observeMessages() {
    this.messagesEl = this.element.querySelector("[id$='_messages']")
    if (!this.messagesEl) return

    this.observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) continue

          if (node.dataset.role === "assistant") {
            clearTimeout(this.recoveryTimer)
            this.#toggleThinking(false)
            this.#toggleForm(true)
            this.#cleanupStreamingElements()
          }
        }
      }
    })

    this.observer.observe(this.messagesEl, { childList: true })
  }

  #toggleThinking(visible) {
    if (this.hasThinkingTarget) {
      this.thinkingTarget.classList.toggle("hidden", !visible)
    }
  }

  #toggleForm(enabled) {
    this.textareaTarget.disabled = !enabled
    this.submitTarget.disabled = !enabled
    if (enabled) this.textareaTarget.focus()
  }

  #cleanupStreamingElements() {
    if (!this.messagesEl) return
    this.messagesEl.querySelectorAll("[id^='streaming-']").forEach(el => el.remove())
  }

  #hideEmptyState() {
    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.add("hidden")
    }
  }
}
